import { $t } from "@/plugins/i18n";

/**
 * 校验邮箱是否正确
 * @param {string} email
 * @returns {Boolean}
 */
export function validateEmail(email: string) {
  return /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(email);
}

/**
 * 校验密码是否符合使用至少 10 个字符，包括大写字母、小写字母和数字的规定
 */
export const passwordReg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{10,}$/;
/**
 * 校验密码是否正确
 * @param {string} email
 * @returns {Boolean}
 */
export const validatePassword = (password: string) => {
  const reasons = [];

  if (!/[a-z]/.test(password)) {
    reasons.push($t("shared.auth.createPasswordReg1"));
  }
  if (!/[A-Z]/.test(password)) {
    reasons.push($t("shared.auth.createPasswordReg2"));
  }
  if (!/\d/.test(password)) {
    reasons.push($t("shared.auth.createPasswordReg3"));
  }
  if (password.length < 8) {
    reasons.push($t("shared.auth.createPasswordReg4"));
  }
  return {
    isValid: reasons.length === 0,
    reasons: reasons
  };
};

/**
 * 校验邮箱并返回校验结果和错误信息
 * @param {string} email
 * @returns {{ isValid: boolean; message: string }}
 */
export const validateEmailMessage = (email: string) => {
  if (!email) {
    return {
      isValid: false,
      message: $t("shared.auth.createEmailReg")
    };
  }

  const isValid = validateEmail(email);

  return {
    isValid,
    message: isValid ? "" : $t("shared.auth.emailCorrectReg")
  };
};
